import { render, staticRenderFns } from "./PanelExpansivo.vue?vue&type=template&id=bb4cf682&scoped=true&"
import script from "./PanelExpansivo.vue?vue&type=script&lang=js&"
export * from "./PanelExpansivo.vue?vue&type=script&lang=js&"
import style0 from "./PanelExpansivo.vue?vue&type=style&index=0&id=bb4cf682&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4cf682",
  null
  
)

export default component.exports